(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AWSErmineWebApp", [], factory);
	else if(typeof exports === 'object')
		exports["AWSErmineWebApp"] = factory();
	else
		root["AWSErmineWebApp"] = factory();
})(this, () => {
return 